export default "__VITE_ASSET__CdziUJEQ__"